// useHydrated — subscribe to the Zustand `persist` hydration lifecycle.
//
// The store routes through an async IDB-backed `StateStorage`
// (`idbStateStorage`), so `persist` resolves the persisted state AFTER first
// paint. Components read empty defaults during that window. This hook lets the
// root gate the initial render behind a "Loading your workspace…" placeholder
// until hydration completes.

import { useEffect, useState } from 'react';
import { useStore } from './index';

export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState<boolean>(() => useStore.persist.hasHydrated());
  useEffect(() => {
    if (useStore.persist.hasHydrated()) {
      setHydrated(true);
      return;
    }
    const unsub = useStore.persist.onFinishHydration(() => setHydrated(true));
    // Re-check on mount in case hydration finished between the initial read
    // and the subscription.
    if (useStore.persist.hasHydrated()) setHydrated(true);
    return unsub;
  }, []);
  return hydrated;
}
